// src/config/kickGames.js
export const KICK_GAME_CONFIGS = {
    'Rust': {
        id: 'rust',
        title: 'Rust',
        image: '/cdk/rust.jpg',
        loginMethods: [
            {
                id: 'steam',
                name: 'Steam登录',
                fields: [
                    {
                        name: 'username',
                        label: 'Steam账号',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam账号'
                    },
                    {
                        name: 'password',
                        label: 'Steam密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入Steam密码'
                    },
                    {
                        name: 'reward_code',
                        label: 'Kick奖励码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Kick奖励码'
                    }
                ],
                // 添加额外的验证字段配置
                extraFields: {
                    emailCode: {
                        name: 'emailCode',
                        label: '邮箱验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam邮箱验证码'
                    },
                    tokenCode: {
                        name: 'tokenCode',
                        label: '令牌验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam令牌验证码'
                    }
                },
                verify: {
                    api: '/api/steam/login_persistent',
                    transformData: (formData) => ({
                        username: formData.username,
                        password: formData.password
                    })
                },
                submit: {
                    api: '/api/steam/login_persistent',
                    transformData: (formData) => {
                        const data = {
                            username: formData.username,
                            password: formData.password,
                            cdkey: formData.cdkey
                        }
                        if (formData.emailCode) {
                            data.email_code = formData.emailCode
                        }
                        if (formData.tokenCode) {
                            data.token_code = formData.tokenCode
                        }
                        return data
                    }
                },
                claim: {
                    api: '/api/bindings/kick/rust',
                    transformData: (formData) => {
                        const data = {
                            username: formData.username,
                            reward_code: formData.reward_code
                        }
                        return data
                    }
                }
            }
        ],
    }
}
